<mat-card>
  <h2 translate>manageAttribution.title</h2>
  <p translate>manageAttribution.subtitle</p>
  <mat-card-content>
    <form [formGroup]="updateAttributionForm" (ngSubmit)="updateAttribution()">
      <div fxFlex fxLayout="row wrap" class="form-wrapper">
        <!-- ROW -->
        <div fxFlex="35" fxFlex.gt-sm="25">
          <mat-form-field fxFlex="100" appearance="outline">
            <mat-label translate>manageAttribution.code</mat-label>
            <input id="code" #name formControlName="code" matInput maxlength="3" type="text" autocomplete="off" />
          </mat-form-field>
        </div>
        <div fxFlex="65" fxFlex.gt-sm="50">
          <mat-form-field fxFlex="100" appearance="outline">
            <mat-label translate>manageAttribution.description</mat-label>
            <input id="description" #name formControlName="description" matInput type="text" autocomplete="off" />
          </mat-form-field>
        </div>
        <div fxFlex="100" fxFlex.gt-sm="25">
          <button
            id="updateBtn"
            class="form__btn-submit"
            mat-flat-button
            color="accent"
            type="submit"
            [disabled]="
              updateAttributionForm?.invalid ||
              updateAttributionForm.controls.code.value == null ||
              updateAttributionForm.controls.description.value == null
            "
          >
            <mat-label translate>manageAttribution.updateBtn</mat-label>
          </button>
        </div>
      </div>
    </form>

    <div class="table__wrapper">
      <table aria-label="attributionsList" mat-table [dataSource]="attributionsList">
        <ng-container matColumnDef="code">
          <th mat-header-cell *matHeaderCellDef class="center less-width padding-right" translate>
            manageAttribution.codeHeaderTitle
          </th>
          <td mat-cell *matCellDef="let element" class="center less-width border-left">{{ element.id }}</td>
        </ng-container>
        <ng-container matColumnDef="description">
          <th mat-header-cell *matHeaderCellDef translate>manageAttribution.descriptionHeaderTitle</th>
          <td mat-cell *matCellDef="let element">{{ element.name }}</td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>
  </mat-card-content>
</mat-card>
